import {combineReducers} from "@reduxjs/toolkit"
import currentPage from './currentPage'
import connState from './connState'
import snacksState from './snacksState'
import loadedOptions from './loadedOptions'

export default combineReducers({
    currentPage, connState, snacksState, loadedOptions
})